import Email from "./email";

export default Email;
